import { render, staticRenderFns } from "./ExameSetting.vue?vue&type=template&id=23abe1e5"
import script from "./ExameSetting.vue?vue&type=script&lang=js"
export * from "./ExameSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports